// 파일명 src / reducer /index.js

import { combineReducers } from 'redux'
import AuthReducer from './AuthReducer'

const rootReducer = combineReducers({
	AuthReducer
});

export default rootReducer
